import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const MOTORCYCLE = {
  nickname: 'PRODUCTS.MOTORCYCLE.nickname',
  properties: [
    { name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'ANSVAR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.DELKASKO', value: 'DELKASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
        ]
      }
    },
    { name: 'parkingInGarage', key: 'PARKING_IN_GARAGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'motoAlarm', key: 'MOTO_ALARM', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'motoLock', key: 'MOTO_LOCK', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'motoSuit', key: 'MOTO_SUIT', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'tffCity', key: 'OBJECT_ADDRESS', group: 'OBJECT_INFO' },
    { name: 'tffZipCode', key: 'OBJECT_ZIP', group: 'INSURANCE_INFO' },
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.2', value: '2000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.4', value: '4000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.6', value: '6000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.8', value: '8000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.10', value: '10000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.12', value: '12000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.25', value: '25000' },
        ]
      }
    },
    { name: 'vehicleBonus', key: 'BONUS', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.0', value: '0' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.10', value: '10' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.20', value: '20' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.30', value: '30' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.40', value: '40' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.50', value: '50' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.60', value: '60' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.70', value: '70' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_1', value: '75,1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_2', value: '75,2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_3', value: '75,3' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_4', value: '75,4' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_5', value: '75,5' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_6', value: '75,6' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.80', value: '80' }
        ]
      }
    },
    { name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required,
        Validators.pattern(/[a-zA-Z]{2}\d{4}/)
      ]]
    },
    { name: 'vehicleRegistrationYear', key: 'REGISTRATION_YEAR', group: 'OBJECT_INFO' },

    { name: 'vehicleBonusYears', key: 'BONUS_YEARS', group: 'INSURANCE_INFO' },
    { name: 'vehicleYoungDriver', key: 'YOUNG_DRIVER', group: 'INSURANCE_INFO' },
    { name: 'vehicleUsageRestrictions', key: 'USAGE_RESTRICTIONS', group: 'INSURANCE_INFO' },
  ],
  icon:'motorcycle'
};
